const emptyPerson = () => ({
  civility: "",
  firstName: "",
  lastName: "",
  birthDate: "",
  birthPlace: "",
  cni: "",
  profession: "",
  phoneDial: "+225",
  phoneNumber: "",
  email: "",
  address: "",
});

const emptyBeneficiary = () => ({
  firstName: "",
  lastName: "",
  birthDate: "",
  birthPlace: "",
  address: "",
  cni: "",
  phoneDial: "+225",
  phoneNumber: "",
});

export const buildEmptyPerson = emptyPerson;
export const buildEmptyBeneficiary = emptyBeneficiary;

export default {
  // ── Étape courante (0..4)
  currentStep: 0,

  // ── Phase : 'form' | 'success'
  appPhase: "form",

  // ── Référence de la souscription (renvoyée par le backend)
  submissionRef: "",

  // ── L'assuré = souscripteur ?
  sameAsSubscriber: false,

  // ── Onglet bénéficiaire actif
  activeBeneficiaryIndex: 0,

  // ── Formulaire complet
  form: {
    contract: {
      projectType: "",
      apporteurType: "Aurée Services", // ← NOUVEAU : 'Aurée Services' | 'Autre'
      apporteurCustom: "",
      cotisation: null,
      duration: "",
      effectDate: "",
    },
    subscriber: emptyPerson(),
    insured: emptyPerson(),
    beneficiaries: [emptyBeneficiary()],
    consentExact: false,
    consentData: false,
    consentTerms: false,
  },

  // ── Fichiers (gardés en mémoire, pas dans le state Vuex sérialisable)
  // On les stocke dans un objet séparé pour éviter les soucis de réactivité avec File
  files: {
    subscriberCni: null,
    insuredCni: null,
  },

  // ── Erreurs de validation
  errors: {
    contract: {},
    subscriber: {},
    insured: {},
    beneficiaries: [{}],
    consent: "",
    submit: "",
  },

  // ── États de chargement
  loading: {
    submit: false,
  },
};
